import React,{ useState, useEffect, useRef } from 'react';

import './AutoSwitching.less'

const AutoSwitching = ({AutoSwitchingData}) =>{
  const [selectExpert, setSelectExpert] = useState(0)

  const [width, setWidth] = useState(window.innerWidth);
  
  let timerRef = useRef();
  useEffect(() => {
    let num = 0;
    console.log(AutoSwitchingData.data)
    setSelectExpert(num)
    if(AutoSwitchingData.data.length > 1){
      timerRef.current = setInterval(()=>{
        num++
        if(num === 5) num = 0
        console.log(num)
        setSelectExpert(num)
      }, 10000)
    }

    
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    

 
    // 清理函数，组件卸载时移除监听器
    return () => {
      clearInterval(timerRef.current)
      window.removeEventListener('resize', handleResize);
    }
  }, []);
  
  return (
    <div className="expert-box">
      <h2 style={{padding: '0 25px'}}>{AutoSwitchingData.title}</h2>
      <div className={width > 770? "expert-content-box":"expert-content-box-phone"}>
        <div className="photo-box">
          <img className="photo" src={selectExpert || selectExpert===0? AutoSwitchingData.data[selectExpert].img:''} alt="" />
        </div>
        <div style={width > 770? {width: '60%'}:{width: '100%'}}>
          <div className="expertList">
            {AutoSwitchingData.data.map((e,i)=>{
              // console.log(selectExpert)
              return (
                <div 
                  className="circle-container" 
                  key={e.name} 
                  onClick={()=> {
                    clearInterval(timerRef.current)
                    
                    if(AutoSwitchingData.data.length > 1){
                      let num = i;
                      setSelectExpert(num)
                      timerRef.current = setInterval(()=>{
                        num++
                        if(num === 5) num = 0
                        console.log(num)
                        setSelectExpert(num)
                      }, 10000)
                    }
                
                  }}
                >
                  <svg className="circle" viewBox="0 0 32 32" width={width > 770? "66":"55"} height={width > 770? "66":"55"}>
                    <circle className="circle-bg" r="15" cx="16" cy="16" />
                    <circle className={selectExpert === i? "circle-progress hover":"circle-progress"} r="15" cx="16" cy="16" strokeDasharray="94.24777960769379" />
                  </svg>
                  <div className="photo-btn">
                    <img src={e.img} alt="" />
                  </div>
                </div>
              )
            })}
          </div>
          {selectExpert || selectExpert===0? 
            <div className="selectExpert-content">
              <div>{AutoSwitchingData.data[selectExpert].sentence}</div>
              <div>{AutoSwitchingData.data[selectExpert].name}</div>
              <div>{AutoSwitchingData.data[selectExpert].identity}</div>
            </div>
            :
            ''
          }
        </div>
      </div>
    </div>
  )
}

export default AutoSwitching